<template>
  <analytics-sub-page
    title="Compare"
    icon="down-left-and-up-right-to-center"
    css-class="analytics-compare"
    default-label="Compare"
    :show-divisions-dropdown="false"
    :can-download="canDownload"
    :get-sheet-config="getSheetConfig"
  >
    <divisions-metrics ref="metricsRef" />
    <template v-if="portalUpdatesJan2026Enabled">
      <industry-comparison-section :metrics="benchmarkMetrics" :sector="sector" :loading="benchmarkLoading" />
      <BenchmarkMetrics />
    </template>
  </analytics-sub-page>
</template>

<script setup>
import { onBeforeMount, ref } from 'vue';
import ApiClient from '@/ApiClient';
import AnalyticsSubPage from '@/components/AnalyticsSubPage.vue';
import useFeatureFlags from '@/composables/useFeatureFlags';
import BenchmarkMetrics from '@/pages/analyticsBenchmark/components/BenchmarkMetrics.vue';
import IndustryComparisonSection from '@/pages/analyticsBenchmark/components/IndustryComparisonSection.vue';
import DivisionsMetrics from '@/pages/analyticsCompare/components/DivisionsMetrics.vue';

const { portalUpdatesJan2026Enabled } = useFeatureFlags();

const metricsRef = ref(null);
const benchmarkLoading = ref(true);
const sector = ref(null);
const benchmarkMetrics = ref([]);

const fetchBenchmarks = async () => {
  benchmarkLoading.value = true;
  try {
    const data = await ApiClient.getSectorBenchmarks();
    sector.value = data?.sector || null;
    benchmarkMetrics.value = data?.metrics || [];
  } catch (error) {
    console.error('Failed to fetch sector benchmarks:', error);
  }
  benchmarkLoading.value = false;
};

onBeforeMount(() => {
  if (portalUpdatesJan2026Enabled.value) {
    fetchBenchmarks();
  }
});

const canDownload = () => metricsRef.value?.canDownload?.() ?? false;

const getSheetConfig = () => metricsRef.value?.getPdfData?.() || {};
</script>
